// These functions are copied from the @cd2/parts package
//   packages/forms/src/Fields/commonCss.ts

type ITypedSize = number | { rem: number } | { px: number } | { em: number }

export function formPadding(val: ITypedSize | { topAndBottom: ITypedSize; sides: ITypedSize }) {
  if (typeof val === "object" && "topAndBottom" in val) {
    return `${objectOrNumberToSize(val.topAndBottom)} ${objectOrNumberToSize(val.sides)}`
  } else {
    return objectOrNumberToSize(val)
  }
}
export function objectOrNumberToSize(
  val: number | { rem: number } | { px: number } | { em: number },
) {
  if (typeof val === "number") {
    return `${val}px`
  } else {
    const key = Object.keys(val)[0]
    // @ts-ignore
    return `${val[key]}${key}`
  }
}
